import exerciseCardWhiteStyles from "./exercise-card-white.module.less";
import exerciseCardDarkStyles from "./exercise-card-dark.module.less";
import {
    Image,
    Input,
    message,
    Button,
    Card,
    Col,
    ConfigProvider,
    Layout,
    Pagination,
    Row,
    Tabs,
    Table,
    Space,
    Popconfirm
} from 'antd';
import { EyeOutlined, ForkOutlined } from '@ant-design/icons'
import { PageHeader } from "../common/page-header/header";
import React, { useEffect, useRef, useState } from "react";
import PageFooter from "../common/page-footer/footer";
import Search from 'antd/lib/input/Search';
import zhCN from 'antd/lib/locale/zh_CN'
import { Tag } from 'antd';
import Cookies from 'js-cookie';
import { Checkbox } from 'antd';
import { Radio } from 'antd';
import { UpOutlined, DownOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';
import * as constants from '../../constants/constants';

import remarkMath from 'remark-math'
import gfm from 'remark-gfm';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import rehypeKatex from 'rehype-katex'
import 'katex/dist/katex.min.css' // `rehype-katex` does not import the CSS for you

const {TextArea} = Input;

const CheckboxGroup = Checkbox.Group;
import rehypeHighlight from 'rehype-highlight'

import Meta from 'antd/lib/card/Meta';
import { sendHttpPostRequest } from "../../api/http-request";
//import {checkIsTeacher} from "../../component/modal/teacher-authenticate/teacher-authenticate";
const { CheckableTag } = Tag;

const { Content } = Layout
const {TabPane} = Tabs

interface Exercise {
    id: number,
    name: string,
    author: string,
    difficulty: number, //难度
    channel: number, //
    type: number, //题型
    status: number, //状态
    create_time: string,//创建时间
    modify_time: string,//修改时间
}


/* 主观题 */


const optionMap = new Map([["1","A"],["2","B"],["3","C"],["4","D"]])
export interface Props {
    exercise:any,
    renderType:string, //渲染的主题类型，"dark","white"
    projectId: number
}

export const ExerciseCardSubjective: React.FC<Props> = (props) => {

    const {exercise,renderType,projectId} = props
    
    const options = (typeof exercise.options === 'string') ? JSON.parse(exercise.options) : exercise.options
    const [userCode, setUserCode] = useState(exercise.default_code)
    const [running, setRunning] = useState(false);  // 运行中状态
    const [answervisible,setAnswerVisible] = useState(false)

    const [currentStatus, setCurrentStatus] = useState(null as any)
    const [outputs, setOutputs] = useState(null as any)  //运行的输出结果

    const [similarity, setSimilarity] = useState(null as any)

    const exerciseCardStyles = renderType == "white" ? exerciseCardWhiteStyles: exerciseCardDarkStyles
    
    useEffect(()=>{
        
    },[])

    const runCodeCallback = (response: any) => {
        message.destroy();
        if (response.code == -100) {
            // 未登录
            document.getElementById("show-login-modal")!.click();
            // window.location.href = `/oam_login?next=oam_preview_exercise?exercise_id=${exercise.id}`;
        } else if (response.code == 0) {
            // 成功
            // TODO: 答题卡片渲染执行结果，不在这里弹提示
            // TODO: 填空题有的输出图片，需要在卡片渲染出来
            if (response.data.status == true) {
                //message.success(`回答正确${response.data.output}`);

                setOutputs(response.data.output)
                setCurrentStatus(true)
                setSimilarity(response.data.similarity)
            } else {
                setOutputs(response.data.output)
                setCurrentStatus(false)
                setSimilarity(response.data.similarity)
            }
        } else if (response.code == -501) {
            // 权限不足
            document.getElementById("show-login-modal")!.click();
            // window.location.href = `/oam_login?next=oam_preview_exercise?exercise_id=${exercise.id}`;
        } else {
            message.error(response.message);
        }
        setRunning(false);
    }

    //点击了提交按钮
    const exerciseSubmitBtnClick = ()=>{
       /* if (!checkIsTeacher()) {
            document.getElementById("show-teacher-authenticate")!.click();
        } else {
            setCurrentStatus(null as any);
            setRunning(true);
            sendHttpPostRequest(
                'exercise/api/exercise_run/',
                {
                    sessionid: Cookies.get("sessionid"),
                    exercise_id: exercise.id,
                    code: userCode
                },
                runCodeCallback
            )
        }
        */

    }

    //用户编辑代码发生改变
    const onUserCodeChange = (e) =>{
        setCurrentStatus(null as any)
        setUserCode(e.target.value);
    }

    // 看答案回调
    const queryExerciseAnswerCallback = (response: any) => {
        message.destroy();
        if (response.code == -100) {
            // 未登录
            document.getElementById("show-login-modal")!.click();
        } else if (response.code == 0) {
            // 成功
            if (response.exercise_answer) {
                exercise.answer_parse = response.exercise_answer.answer_parse;
                setAnswerVisible(true);
            }
        } else if (response.code == -501) {
            // 权限不足
            // document.getElementById("show-login-modal")!.click();
        } else {
            message.error(response.message);
        }
    }

    //点击了参考答案按钮
    const exerciseAnswerBtnClick = ()=>{
        if (exercise.answer_parse.length == 0) {
            // 查询答案
            sendHttpPostRequest(
                'exercise/api/query_exercise_answer/',
                {
                    sessionid: Cookies.get("sessionid"),
                    sid: Cookies.get("sessionid"),
                    project_id: projectId,
                    exercise_id: exercise.id
                },
                queryExerciseAnswerCallback
            )
        } else {
            setAnswerVisible(!answervisible);
        }
    }

    // 渲染 查看答案按钮
    const renderAnswerButton = () => {
        if (0 == exercise.answer_parse.length) {
            return (
                <Popconfirm placement="bottom" title={'您确定查看答案吗？'} onCancel={(e:any)=>{e.stopPropagation();}} onConfirm={(e:any)=>{e.stopPropagation();exerciseAnswerBtnClick()}} okText="确认" cancelText="取消">
                    <Button   type='link' style={{width:80,marginRight:10,borderRadius:20}}> <span>答案解析</span><DownOutlined /> </Button>
                </Popconfirm>
            )
        } else {
            return (
                <Button onClick={exerciseAnswerBtnClick} type='link' style={{width:80,marginRight:10,borderRadius:20}}><span>答案解析</span>{!answervisible ? <DownOutlined/> : <UpOutlined/>}</Button>
            )
        }
    }

    const getRunnigStatusBtn = () => {
        if(currentStatus == true){
            return <Button onClick={exerciseSubmitBtnClick}  type='default' style={{paddingLeft:5,borderRadius:3,width:80,color:"#22c55e",borderColor:"#22c55e"}}> {similarity + "%"}</Button> 
        }else if (currentStatus == false) {
            return  <Button onClick={exerciseSubmitBtnClick}    type='default' style={{paddingLeft:5,borderRadius:3,width:80,color:"#22c55e",borderColor:"#22c55e"}} > {similarity +"%"} </Button> 
        }else {
            return <Button onClick={exerciseSubmitBtnClick}   type='primary' style={{borderRadius:3,width:80}}> 测 试 </Button>
        }
    }

    
    return (
        <div style={{marginBottom:20,textAlign:'left'}} className={exerciseCardStyles.wrapper}>
            <div style={{marginBottom:10,fontSize:14}}>
            <ReactMarkdown  
                className={exerciseCardStyles.reactmarkdownTitle}
                remarkPlugins={[gfm,remarkMath]}
                rehypePlugins={[rehypeHighlight,rehypeKatex]}
             >
                {"【主观题】" + exercise.title}
             </ReactMarkdown>

             <div style={{marginTop:10,marginBottom:10}}>
                <ConfigProvider locale={zhCN}>
                    <Row justify="center" align="middle" gutter={[10,10]}>
                    {exercise?.images?.map((image:any)=>{
                        return <Col key={image.name} >
                            <Image
                            width={360}
                            height={270}
                            preview={false}
                            src={constants.BACKEND_URL + image.path + image.name}
                            />
                    </Col>
                    })}
                    </Row>
                </ConfigProvider>
             </div>

                </div>
            <div style={{paddingLeft:20,marginBottom:10}} >
                <TextArea 
                    placeholder="请输入您的答案" 
                    rows={4}
                    style={{width:"100%",borderRadius:4,borderColor:"#cccccc"}} 
                    defaultValue={exercise?.reference_answer}
                    onChange={onUserCodeChange}/>
             </div>

            <Row justify="start" align="middle" gutter={[8,8]} style={{marginTop:20}}>
            <Col flex={"100px"} style={{textAlign:"left"}} >
              {getRunnigStatusBtn()}
              </Col>
              <Col flex={"auto"} style={{textAlign:"left"}}>
                
              </Col>
              <Col flex={"100px"} style={{textAlign:"right"}}>
                  {renderAnswerButton()}
              </Col>
            </Row>

            { answervisible && <div style={{marginTop:10,padding:10,borderRadius:5}} className={exerciseCardStyles.answerParse}
            >
            <ReactMarkdown  
                className={exerciseCardStyles.reactmarkdown}
                remarkPlugins={[gfm,remarkMath]}
                rehypePlugins={[rehypeKatex,rehypeRaw]}
            >
            {exercise?.answer_parse}
            </ReactMarkdown>
                                              
            </div>
            }
            
        </div>
    )

}

export default  ExerciseCardSubjective